import React, { useEffect, useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const ListViewModal = ({ render = false, modalTitle = '', triggerButtonComponent = null, childrenComponent = null, footerComponent = null }) => {
    const [modal, setModal] = useState(render)

    useEffect(() => {
        if (render !== modal)
            setModal(render)
    }, [render])

    const toggle = () => setModal(!modal)

    return <>
        <span onClick={toggle}>{triggerButtonComponent}</span>
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>{modalTitle}</ModalHeader>
            <ModalBody>
                {React.Children.toArray(childrenComponent)}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Close</Button>
                {footerComponent}
            </ModalFooter>
        </Modal>
    </>
}

export default ListViewModal;